import { Leaf } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20 md:py-24">
      <Leaf className="w-6 h-6 text-[var(--forest)]" strokeWidth={1.5} />
      <p className="label-eyebrow mt-3">Our wager</p>
      <h1 className="font-serif text-5xl md:text-6xl mt-2 leading-tight">Why this exists. Why it costs $4.</h1>
      <hr className="divider-rule" />
      <div className="space-y-6 text-lg text-[var(--ink-soft)] leading-relaxed">
        <p>
          The wellness industry sells you bottled extracts of plants that already grow,
          for free, within a hundred yards of where you're sitting. We think that's
          backwards. The most powerful field guide should cost less than the cheapest
          bottle of supplements on the shelf.
        </p>
        <p>
          So here is a single, plain-spoken book — built around the four pillars that
          actually move the needle: fat metabolism, heavy-metal clearance, cognitive
          recovery, and quiet daily resilience. Every entry was written by someone
          who has used the plant, against a primary literature review, with
          identification cautions a beginner can actually follow.
        </p>
        <p className="text-[var(--ink)]">
          Pay <span className="font-mono text-[var(--terracotta)]">$4</span> once. Read it forever. Disagree with us in writing.
          That's the whole arrangement.
        </p>
      </div>
    </div>
  );
}
